/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Box, Button, Grid, List, Typography, useTheme } from "@mui/material";
import ModalFirma from "@components/Firma/ModalFirmaMifiel";
import { DocumentContract } from "@interfaces/response";
import ListDocuments from "@components/ListDocuments";

interface FirmaMiFielProps {
  documents: DocumentContract[];
}

interface PersonWithWidget {
  person_id: string;
  name: string;
  file_name: string[];
  widget_id: string[];
}

const FirmaMiFiel: React.FC<FirmaMiFielProps> = ({ documents }) => {
  const theme = useTheme();
  const [personsToSign, setPersonsToSign] = useState<PersonWithWidget[]>([]);
  const [widgetsToSign, setWidgetsToSign] = useState<string[]>([]);

  useEffect(() => {
    try {
      const documents_with_signers = documents.filter(
        (document) => document.signers_reference && document.signers_reference.length > 0,
      );

      const documents_with_external_signers = documents_with_signers.filter((document) =>
        document.signers_reference?.some((signer) => signer.type === "external"),
      );

      console.log("documents_with_external_signers", documents_with_external_signers);

      const mifiel_documents: DocumentContract[] = [];

      documents_with_external_signers.forEach((document) => {
        mifiel_documents.push(document);
      });

      const personsToSign: PersonWithWidget[] = [];

      documents_with_external_signers.forEach((document) => {
        document.signers_reference.forEach((element) => {
          const { person_id, name, widget_id, type } = element;
          if (person_id && widget_id && type === "external") {
            const personaAdded = personsToSign.find((item) => item.person_id === person_id);

            if (personaAdded) {
              personaAdded.widget_id.push(widget_id);
              personaAdded.file_name.push(document.file_category.name);
            } else {
              personsToSign.push({ person_id, name, file_name: [document.file_category.name], widget_id: [widget_id] });
            }
          }
        });
      });

      setPersonsToSign(personsToSign);
    } catch (error) {
      console.log("Ha ocurrido un error al obtener los documentos: ", error);
    }
  }, [documents]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {personsToSign.map((person) => (
        <Box
          key={person.person_id}
          borderBottom="1px solid #e0e0e0"
          p={2}
          sx={{
            backgroundColor: theme?.palette?.components?.phoneInput?.main || theme?.palette?.primary?.base,
            borderRadius: "10px",
            padding: "20px",
            maxWidth: "98%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={8} xs={12} display="flex" alignItems="flex-start" flexDirection="column">
              <Typography fontWeight="bold">{person.name}</Typography>
              <List sx={{ listStyleType: "disc", paddingLeft: 2 }}>
                {person.file_name.map((file) => (
                  <ListDocuments key={file} title={file} />
                ))}
              </List>
            </Grid>

            <Grid item md={4} xs={12} display="flex" justifyContent="flex-end" alignItems="center">
              <Button variant="default" onClick={() => setWidgetsToSign(person.widget_id)} sx={{ height: "50px" }}>
                Firmar documentos
              </Button>
            </Grid>
          </Grid>
        </Box>
      ))}

      {widgetsToSign.length > 0 && (
        <ModalFirma
          widgetIds={widgetsToSign}
          handleClose={() => setWidgetsToSign([])}
          handleSuccess={() => {
            console.log("success");
          }}
        />
      )}
    </Box>
  );
};

export default FirmaMiFiel;
